import axios from 'axios'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'

const servicioRestPost = async ({ servicioUrl, peticionServicio, headers = { TOKEN_AUTORIZACION: null, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false } }, conMensajeCargaDeInformacion = false) => { 
    let estatusDeProceso = { CON_ERROR: false, RESPUESTA: null };
    try {
        const { TOKEN_AUTORIZACION, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER } = headers;
        const SERVIDOR = api.conexion;
        const METODO_API = servicioUrl;
        const URL_SERVICIO_REST = SERVIDOR + METODO_API;
        const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(TOKEN_AUTORIZACION, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
        if(conMensajeCargaDeInformacion)
            comun.SeEstaCargandoInformacion(true);
        const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticionServicio, HEADER_SERVICIO_REST);
        estatusDeProceso.RESPUESTA = await RESPUESTA.data;
        comun.SeEstaCargandoInformacion(false);
    }
    catch(excepcion) {
        estatusDeProceso.CON_ERROR = true;
        console.log(excepcion);
        comun.SeEstaCargandoInformacion(false);
        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
    }
    return estatusDeProceso;
}


export { servicioRestPost };


// WEBPACK FOOTER //
// ./src/components/Audiencias/Programacion/servicios/ServiciosHttp.js